import effectManager from '../effect';
import Param from '../../param';

const param = new Param();
const effect = new effectManager();

export default class globalNavi{
    constructor(){

        /* 必要なDOM */
        this.$header = $("#l-header__inner");
        this.$nav = $("#l-header-navi");
        this.$list = this.$nav.find("li");
        this.$logo =  $("#l-header-logo");
        this.$moviePlay =  $("#l-header-play");
        this.$moviePlayText =  $("#l-header-play-text");
        this.$moviePlayIcon =  $("#l-header-play-icon >*");

        this.side = {
            $all  : $(".p-navi"),
            $next : $("#p-btn-next"),
            $prev : $("#p-btn-prev"),
        }

        /* 設定 */
        this.conf = {
            MAX : $(".p-section").length
        }

        /* ステータス */
        this.status = {
            now : "close",
        }



    }
    init() {
        setTimeout(()=>TweenMax.set(this.side.$all.find(".p-navi-text-view .js__btn-split.is-none >* >*"),{opacity:0}),1e3);

        setTimeout(()=>effect.btnLine(this.$logo,"show"),2e3);
    }
    update(current,prevCurrent){


        /* グロナビ */
        if(!Useragnt.mobile) {
            if (current == 0) {
                this.$logo.addClass("is-current");
                effect.btnLine(this.$logo, "show");
            }
            if (prevCurrent == 0) {
                this.$logo.removeClass("is-current");
                effect.btnLine(this.$logo, "out");
            }
        }
        let _gnaviCurrent = current-1;

        if(!Useragnt.mobile) {
            this.$list.removeClass("is-current");
            this.$list.eq(_gnaviCurrent).addClass("is-current");
        }

        if(_gnaviCurrent>=0) effect.btnLine(this.$list.eq(_gnaviCurrent),"show");
        if(prevCurrent!=0) effect.btnLine(this.$list.eq(prevCurrent-1),"out");


        /* サイドナビ */
        let _prevNavi = {
            $prev:this.side.$prev.find(".p-navi-text-view").eq(this.side.$prev.attr("data-select")),
            $next: this.side.$next.find(".p-navi-text-view").eq(this.side.$next.attr("data-select")),
            MAX :  this.side.$next.find(".p-navi-text-view").length,
            nextCurrent: 0,
            prevCurrent: 0,
        };


        _prevNavi.nextCurrent = _prevNavi.MAX-1>current++ ? current++ : 0;
        _prevNavi.prevCurrent = 0<=_prevNavi.nextCurrent-2 ? _prevNavi.nextCurrent-2 : -1<=_prevNavi.nextCurrent-2?_prevNavi.MAX-1:_prevNavi.MAX-2;
        // _prevNavi.prevCurrent = 0<current-2 ? current-2 : _prevNavi.MAX-1;

        if(!Useragnt.mobile){
            effect.btn(_prevNavi.$prev,"out","update");
            effect.btn(_prevNavi.$next,"out","update");
            _prevNavi.$prev.children().addClass("is-none");
            _prevNavi.$next.children().addClass("is-none");

            this.side.$prev.attr("data-select",_prevNavi.prevCurrent);
            this.side.$next.attr("data-select",_prevNavi.nextCurrent);

            this.side.$prev.find(".p-navi-text-view").eq(_prevNavi.prevCurrent).children().removeClass("is-none");
            this.side.$next.find(".p-navi-text-view").eq(_prevNavi.nextCurrent).children().removeClass("is-none");

            effect.btn(this.side.$prev.find(".p-navi-text-view").eq(_prevNavi.prevCurrent),"show","update");
            effect.btn(this.side.$next.find(".p-navi-text-view").eq(_prevNavi.nextCurrent),"show","update");
        }


        /* グロナビ　カラーを更新 */
        //this.side.$all
        if(_gnaviCurrent==1||_gnaviCurrent==2){
            TweenMax.to(this.$logo.find(".st0"),0.3,{fill:"#000"});
            TweenMax.to($(".p-navi-line"),0.3,{backgroundColor:"rgba(0,0,0,0.15)"});
            TweenMax.to(this.$header,0.3,{borderBottomColor:"rgba(0,0,0,0.15)"});

            if(Useragnt.mobile){
                TweenMax.to(this.$moviePlay,0.3,{borderLeftColor:"rgba(0,0,0,0.15)"});
                TweenMax.to(this.$moviePlayText,0.3,{color:"#000"});
                TweenMax.to(this.$moviePlayIcon.find(".cls-1"),0.3,{fill:"#000"});
                TweenMax.to(this.$moviePlayIcon,0.3,{borderColor:"#000"});
            }else{
                TweenMax.to($(".js__c-split >* >*"),0.3,{color:"#000"});
                TweenMax.to($(".js__c-line"),0.3,{backgroundColor:"#000"});
            }
            // this.$moviePlay
        }else{
            TweenMax.to(this.$logo.find(".st0"),0.3,{fill:"#fff"});
            TweenMax.to($(".p-navi-line"),0.3,{backgroundColor:"rgba(255,255,255,0.3)"});
            TweenMax.to(this.$header,0.3,{borderBottomColor:"rgba(255,255,255,0.3)"});

            if(Useragnt.mobile){
                TweenMax.to(this.$moviePlay,0.3,{borderLeftColor:"rgba(255,255,255,0.3)"});
                TweenMax.to(this.$moviePlayText,0.3,{color:"#fff"});
                TweenMax.to(this.$moviePlayIcon.find(".cls-1"),0.3,{fill:"#fff"});
                TweenMax.to(this.$moviePlayIcon,0.3,{borderColor:"#fff"});
            }else{
                TweenMax.to($(".js__c-split >* >*"),0.3,{color:"#fff"});
                TweenMax.to($(".js__c-line"),0.3,{backgroundColor:"#fff"});
            }
        }


    }
    resize(){

    }
}